<div class="d-flex">
  <app-mobile-header-main
    (titleClicked)="openTaxonomyMenu = $event"
    [mainTitle]="!route.snapshot.params.groupId ? translateService.instant('menu.wholeGroup') : currentGroup?.name"
    menulink="/menu/documentos"
  ></app-mobile-header-main>
  <div class="taxonomy-overlay" [class.taxonomy-overlay-active]="openTaxonomyMenu" (click)="openTaxonomyMenu = false"></div>
  @if (urlParamsService.params.sidebar) {
    <app-taxonomy mainTitle="{{ 'menu.documents' | translate }}" allowSearch [(isSearchOpen)]="isSearchOpen" (isSearchOpenChange)="toggleSearch($event)" [class.isMenuMobileOpen]="openTaxonomyMenu">
      <app-documents-taxonomy [isSearchOpen]="isSearchOpen" (sortingChange)="loadDocuments({ page: 1, search: searchQuery })" [listPath]="'group'"></app-documents-taxonomy>
    </app-taxonomy>
  }
</div>

<div class="d-flex flex-column w-100">
  @if (isSearchOpen) {
    <app-documents-search
      [(search)]="searchQuery"
      [selectedMemberOrGroup]="currentGroup ? { id: currentGroup.uuid, name: currentGroup.name, type: 'group' } : null"
      (searchChange)="pageNumber = 1; loadDocuments({ page: 1, search: $event })"
      (closeClick)="isSearchOpen = false; toggleSearch(isSearchOpen)"
      @slideDownUpTrigger
    ></app-documents-search>
  }

  <div class="documents">
    <app-electron-deprecation-warning></app-electron-deprecation-warning>

    <div class="documents__header justify-content-start">
      @if ((isSearchOpen && searchQuery) || mobileSearch) {
        <h2 class="documents__title">{{ 'documents.searchResults' | translate }}</h2>
      } @else if (route.snapshot.params.groupId) {
        <h2 class="documents__title">{{ currentGroup?.name }}&nbsp;</h2>
      } @else {
        <h2 class="documents__title">{{ 'menu.wholeGroup' | translate }}</h2>
      }
      <app-search [(query)]="mobileSearch" (queryChange)="pageNumber = 1; loadDocuments({ page: 1, search: { search: $event } })"></app-search>
      @if (isSearchOpen && searchQuery) {
        <button type="button" class="btn-text btn-M icon-start ml-2" [disabled]="isLoading" (click)="exportDocuments(searchQuery)">
          <i class="far fa-file-csv"></i>
          {{ 'documents.export' | translate }}
        </button>
      }
    </div>

    @if (currentUser && !searchQuery && !mobileSearch && !appService.documentStatusFilter && documents && documents.length === 0) {
      <div class="documents-empty">
        <img src="/assets/alerts/confirmation-2.svg" alt="" />
        <p class="documents-empty__title">{{ 'documents.noDocumentsHere' | translate }}</p>

        @if (urlParamsService.params.folderBreadCrumbs) {
          <button type="button" routerLink="/pastas" class="btn-M btn-filled-cancel">{{ 'button.accessFolders' | translate }}</button>
        }
        @if (currentUser?.currentPermissions.create_documents) {
          <button type="button" (click)="routeToNewDocument()" class="btn-M btn-filled">
            {{ 'documents.createADocument' | translate }}
          </button>
        }
      </div>
    } @else if (currentUser && !isLoading && documents && (searchQuery || mobileSearch || appService.documentStatusFilter) && documents.length === 0) {
      <div class="documents-filtered-empty">
        <div class="documents-filtered-empty_title">{{ 'settings.nothingHere' | translate }}</div>
        <div class="documents-filtered-empty_text">
          <span>{{ 'documents.noDocumentsMatchingFilter' | translate }}</span>
        </div>
        <button type="button" class="default-button" (click)="clearFilters()">{{ 'documents.clearFilters' | translate }}</button>
      </div>
    }

    @if (appService.listFormat === ListFormat.Box) {
      <app-documents-list-boxes
        [currentUser]="currentUser"
        [hidePagination]="isLoading || isLastPage || pageNumber > 99"
        (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
        [documents]="documents"
        (signClick)="sign($event)"
        (folderClick)="openFoldersModal({ documents: $event })"
        (deleteClick)="delete($event)"
        (transferClick)="transfer($event)"
        (toggleBlockClick)="toggleBlock($event)"
        (resendWebhookClick)="resendWebhook($event)"
      >
      </app-documents-list-boxes>
    }

    @if (appService.listFormat === ListFormat.List) {
      <app-documents-list-table
        [currentUser]="currentUser"
        [hidePagination]="isLoading || isLastPage || pageNumber > 99"
        (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
        (sortingChange)="loadDocuments({ page: 1, search: searchQuery })"
        [documents]="documents"
        (signClick)="sign($event)"
        (folderClick)="openFoldersModal({ documents: $event })"
        (deleteClick)="delete($event)"
        (transferClick)="transfer($event)"
        (toggleBlockClick)="toggleBlock($event)"
        (resendSignaturesClick)="resendSignatures($event)"
        (resendWebhookClick)="resendWebhook($event)"
      >
      </app-documents-list-table>
    }
  </div>
</div>
